{
  "actionbar.actions": "Дії",
  "actionbar.actionsAvailable": "Доступні дії.",
  "actionbar.clearSelection": "Очистити вибір",
  "actionbar.selected": "Вибрано: {count}",
  "actionbar.selectedAll": "Усе вибрано",
  "button.pending": "в очікуванні",
  "calendar.invalidSelection": "{selectedCount, plural, one {Вибрана дата недоступна} other {Вибрані дати недоступні}}.",
  "contextualhelp.help": "Довідка",
  "contextualhelp.info": "Інформація",
  "datepicker.endTime": "Час завершення",
  "datepicker.startTime": "Час початку",
  "datepicker.time": "Час",
  "dialog.alert": "Сигнал тривоги",
  "dialog.dismiss": "Скасувати",
  "dropzone.replaceMessage": "Перетягніть файл для заміни",
  "inlinealert.informative": "Інформація",
  "inlinealert.negative": "Помилка",
  "inlinealert.notice": "Попередження",
  "inlinealert.positive": "Успішно",
  "label.(optional)": "(необов’язково)",
  "label.(required)": "(обов’язково)",
  "menu.moreActions": "Більше дій",
  "picker.placeholder": "Вибрати…",
  "slider.maximum": "Максимум",
  "slider.minimum": "Мінімум",
  "table.loading": "Завантаження…",
  "table.loadingMore": "Завантаження інших об’єктів...",
  "table.resizeColumn": "Змінити розмір стовпця",
  "table.sortAscending": "Сортувати за зростанням",
  "table.sortDescending": "Сортувати за спаданням",
  "tag.actions": "Дії",
  "tag.hideButtonLabel": "Показувати менше",
  "tag.noTags": "Немає",
  "tag.showAllButtonLabel": "Показати всі ({tagCount, number})",
  "breadcrumbs.more": "Більше елементів",
  "combobox.noResults": "Результатів немає",
  "notificationbadge.indicatorOnly": "Нова активність",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}